import { useEffect, useRef, type RefObject } from 'react';

type ResizeObserverCallback = (entry: DOMRectReadOnly) => void;

const useResizeObserver = (
  callback: ResizeObserverCallback
): RefObject<HTMLDivElement | null> => {
  const ref = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const element = ref.current;
    if (!element) return;

    const resizeObserver = new ResizeObserver((entries) => {
      for (const entry of entries) {
        callback(entry.contentRect);
      }
    });

    resizeObserver.observe(element);

    return () => resizeObserver.disconnect();
  }, [callback]);

  return ref;
};

export default useResizeObserver;
